module.exports = __webpack_public_path__ + "static/media/reserved.96961cc8.svg";